/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function InlineObject8FromJSON(json) {
    return InlineObject8FromJSONTyped(json, false);
}
export function InlineObject8FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}
export function InlineObject8ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'theme': value.theme,
        'token': value.token,
    };
}
